import type {
  ContentListApiResponse,
  ContentListResponse,
  ContentPost,
} from 'api/new-analytics/types';

export function resolvePreviewContentPosts(
  data: ContentListApiResponse | ContentListResponse | undefined,
): ContentPost[] {
  if (!data) {
    return [];
  }

  if ('data' in data && data.data?.posts) {
    return data.data.posts;
  }

  if ('posts' in data && data.posts) {
    return data.posts;
  }

  return [];
}
